export class DrillHole {
    azimuth: number;
    comments: any;
    company_hole_id: string;
    company_name: string;
    contact_rgp: any[] = [];
    coordinate_source: string;
    dh_type: string;
    dip: number;
    drill_core: any[] = [];
    elements: any[] = [];
    id: number;
    lat_dec: number;
    length: number;
    length_unit: string;
    ll_datum: string;
    lng_dec: number;
    nts_num: string;
    overburden: number;
    property_name: string;
    rgp_district: string;
    tech_id: string;
    township: string;
    last_updated_at: string;
    last_updated_detail: string;
    utm_datum: string;
    utm_easting: number;
    utm_northing: number;
    utm_zone: number;
    year_drilled: number;
  
    constructor(init?: Partial<DrillHole>) {
      Object.assign(this, init);
    }
  }